import React from 'react';
import { Select } from 'antd';

interface Props {
  loading: boolean;
  drivers: { id: number; name: string }[];
  defaultValue: number;
  onSelect: (id: number) => void;
}

const DriverSelector: React.FC<Props> = ({ loading, drivers, defaultValue, onSelect }) => {
  return (
    <Select<number>
      loading={loading}
      style={{ width: '150px', marginBottom: '10px' }}
      placeholder='Bezorger'
      showSearch
      optionFilterProp='children'
      defaultValue={defaultValue}
      onSelect={onSelect}
    >
      {drivers.map((driver, index) => (
        <Select.Option key={index} value={driver.id}>
          {driver.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export { DriverSelector };
